export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-03.620fc8ec.jpg";